import React, { useEffect } from 'react';
import { BuildingsProvider } from '../../store';
import BuildingsContent from '../../components/buildings-content/buildings-content.component';
import { CommonService } from '../../services/common/common.service';
import { useTranslation } from 'react-i18next';
import HeaderComponent from "../../components/header/header.component";
import { headerWithTableHeight } from 'src/statics/header';

export default function BuildingsPage() {
  const commonService = new CommonService();
  const [t] = useTranslation();
  useEffect(() => {
    const title = t('buildings');
    commonService.setTitle(title);
    // eslint-disable-next-line
  }, []);
  return (
    <BuildingsProvider>
      <HeaderComponent title="buildings page" headerHeight={headerWithTableHeight} displayMenu={true}/>
      <BuildingsContent />
    </BuildingsProvider>
  );
}
